export const RewardsTermAndConditionsTempComponent = () => {
  return (
    <>
      <p className="title-tnc">ZEE REWARDS PROGRAM TERMS AND CONDITIONS</p>
      <p>&nbsp;</p>
      <p>
        <strong className="weight-bold">INTRODUCTION:</strong>
      </p>
      <p>
        ZEE Rewards Program (&quot; Program &rdquo;) is designed and operated by
        Zee Entertainment Enterprises Limited (&quot; ZEE &rdquo;) to recognize
        and reward the loyalty of users (&quot; Users &rdquo;) of the ZEE5 App (
        &quot; Platform &rdquo;). By participating in the Program, Users agree
        to abide by the following terms and conditions (&quot; Terms &rdquo;):
      </p>
      <p>&nbsp;</p>
      <ul>
        <strong className="weight-bold">1. ZeeCoins ALLOCATION:</strong>
      </ul>
      <p>&nbsp;</p>
      <p>
        ZeeCoins are loyalty points awarded to Users for their consistent and
        regular engagement with the Platform. These loyalty points are allocated
        to Users for various actions, including but not limited to:
      </p>
      <ul>
        <li>Registration on ZEE5</li>
        <li>Enrollment in ZeeRewards</li>
        <li>Completion of user profiles</li>
        <li>Content sharing with acquaintances</li>
        <li>Referral of new users</li>
        <li>Viewing ILT20 live matches</li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <strong className="weight-bold">2. REDEEMING REWARDS:</strong>
      </ul>
      <p>&nbsp;</p>
      <p>
        Upon accrual of a predetermined amount of ZeeCoins, Users have the
        opportunity to redeem them for rewards such as vouchers and prizes. The
        redemption process is subject to the terms specified by ZEE and may vary
        based on availability and other factors determined by ZEE.
      </p>
      <p>&nbsp;</p>
      <ul>
        <strong className="weight-bold">3. TERMS AND CONDITIONS:</strong>
      </ul>
      <p>&nbsp;</p>
      <p>
        By participating in the Program, Users acknowledge and agree to the
        following:
      </p>
      <ul>
        <li>
          ZeeCoins cannot be converted to cash or used as a substitute for cash.
        </li>
        <li>
          ZeeCoins are non-transferable, and any unauthorized transfer thereof
          shall be deemed void from inception.
        </li>
        <li>
          ZeeCoins cannot be utilized for direct purchases on the Platform.
        </li>
        <li>
          ZeeCoins hold no monetary value, and Users are not entitled to
          monetary compensation in the event of ZeeCoins loss or for settlement
          purposes.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <strong className="weight-bold">4. MODIFICATION:</strong>
      </ul>
      <p>&nbsp;</p>
      <p>
        ZEE reserves the exclusive right, at its sole discretion, to modify the
        allocation mechanism of ZeeCoins, including the quantity awarded based
        on User activities. Furthermore, ZEE reserves the right to disqualify
        any User found to be in violation of the Program terms, engaged in
        fraudulent activities, or failing to comply with legal obligations and
        regulations.
      </p>
      <p>
        Additionally, ZEE may, at its discretion, discontinue, alter, or
        introduce new forms of loyalty points without prior notice. ZEE also
        reserves the right to specify an expiry period for ZeeCoins.
      </p>
      <p>&nbsp;</p>
      <ul>
        <strong className="weight-bold">5. EXCLUSIVITY OF ZeeCoins:</strong>
      </ul>
      <p>&nbsp;</p>
      <p>
        ZeeCoins are awarded solely for the regular utilization of the ZEE5 App,
        and no alternative means of acquisition or purchase is permissible.
      </p>
      <p>&nbsp;</p>
      <ul>
        <ul>
          <strong className="weight-bold">6. DISCLAIMER:</strong>
        </ul>
      </ul>
      <p>&nbsp;</p>
      <p>
        a)ZEEL is not responsible for the loss of any nature, and/or any
        physical injury and/or disability and/or disfigurement and/or mental
        trauma and/or death that may occur/ occurs to the participant, who has
        been considered as invalid and/or not selected and/or selected as a
        winner while participating in ZeeRewards, in relation to ZeeRewards and/
        or Gratification and/or Grand Prize.
      </p>
      <p>&nbsp;</p>
      <p>
        b)The interpretation and implementation of the Rules &amp; Regulation
        shall be at the sole discretion of ZEEL. The decisions of ZEEL shall be
        final and binding, and not subject to challenge or appeal.
      </p>
      <p>&nbsp;</p>
      <p>
        c)TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW OF INDIA, ZEE5
        AND/OR ZeeRewards IS PROVIDED ON AN &quot; AS IS &rdquo; BASIS WITHOUT
        WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. WITHOUT LIMITING THE FOREGOING
        PROVISIONS, YOU ASSUME SOLE RISK AND RESPONSIBILITY FOR SELECTING ZEE5
        TO ACHIEVE YOUR INTENDED RESULTS, AND SOLE RESPONSIBILITY FOR THE
        INSTALLATION OF, USE OF, REGISTRATION, AND RESULTS OBTAINED FROM ZEE5.
        WITHOUT LIMITING THE FOREGOING PROVISIONS, ZEEL MAKES NO WARRANTY THAT
        ZEE5 WILL BE ERROR-FREE, VIRUS FREE, OR FREE FROM INTERRUPTIONS OR OTHER
        FAILURES OR THAT THE ZEE5 WILL SATISFY YOUR SPECIFIC REQUIREMENTS OR
        THAT THE ERRORS WILL BE RECTIFIED. YOU UNDERSTAND THAT ZEE5 AN BE
        BLOCKED OR MADE INOPERABLE AND ZEEL ASSUMES NO RESPONSIBILITY OR
        LIABILITY FOR THE SAME. ZEE5 IS NOT FAULT-TOLERANT AND IS NOT DESIGNED
        OR INTENDED FOR USE IN HAZARDOUS ENVIRONMENTS REQUIRING FAIL-SAFE
        PERFORMANCE, INCLUDING WITHOUT LIMITATION, IN THE OPERATION OF NUCLEAR
        FACILITIES, AIRCRAFT NAVIGATION OR COMMUNICATION SYSTEMS, AIR TRAFFIC
        CONTROL, WEAPONS SYSTEMS, DIRECT LIFE-SUPPORT MACHINES, OR ANY OTHER
        APPLICATION IN WHICH THE FAILURE OF ZEE5 NETWORK COULD LEAD DIRECTLY TO
        DEATH, PERSONAL INJURY, OR SEVERE PHYSICAL OR PROPERTY DAMAGE
        (COLLECTIVELY, &quot; HIGH RISK ACTIVITIES &rdquo;). ZEEL EXPRESSLY
        DISCLAIMS ANY EXPRESS OR IMPLIED WARRANTY OF FITNESS FOR HIGH RISK
        ACTIVITIES.
      </p>
      <p>&nbsp;</p>
      <ul>
        <strong className="weight-bold">10. OTHER TERMS AND CONDITIONS</strong>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          a) ZeeRewards is meant for entertainment and recreational purposes
          only, and is not a bet, award or challenge, sponsor, promotion, or any
          other form of formal event.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          b) Any loss or outrage or dissatisfaction suffered during using
          ZeeRewards by Participant(s) would not be the responsibility of ZEEL
          and/or its associates and affiliates, who will not be responsible to
          make good any such loss or dissatisfaction. Under no circumstances
          whatsoever, will the Participant(s) be entitled to claim any damages
          against ZEEL and/or its associates and affiliates including but not
          limited to General and Special Damages, Consequential, Pecuniary and
          Non-Pecuniary, Liquidated, Aggravated, Exemplary Damages, Compensatory
          and Non-Compensatory, Nominal and Damages for Loss of Profit/ Loss of
          Opportunity.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          c) ZEEL will endeavour to ensure that the integrity of the ZeeRewards
          is maintained at all times and will take reasonable steps in this
          regard. In the event ZEEL receives information that the integrity of
          ZeeRewards has been compromised in any manner, including by using
          unfair or unlawful means, ZEEL reserves the right to take all actions,
          including suspending the Participant from ZeeRewards, to protect
          itself, the Application, and ZeeRewards.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          d) By accepting the Rules &amp; Regulations, the Participant agrees
          and authorizes ZEEL to use any information available and linked to his
          Unique Identifier (Phone number, Email) provided at the time of
          registration on the Application. The Participation in ZeeRewards will
          be governed by the Indian Data Privacy requirements only.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          e) None of the Participants shall, without the prior written approval
          of ZEEL, speak to the press or any other media or any third person,
          nor give any interviews or comments relating to any aspect of
          ZeeRewards. The Participant shall not disclose any information
          whatsoever relating to ZEEL to any other party including screen shots
          of ZeeRewards on social media websites. Violation of this clause shall
          immediately disqualify the Participant&rsquo;s prospects of further
          participation.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          f) ZEEL reserves the right to disqualify any Participant(s) form
          ZeeRewards at its sole discretion without assigning any reasons
          whatsoever. Such decision of ZEEL shall be final and binding on all
          Participant(s).
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <ul>
        <strong className="weight-bold">11. INTELLECTUAL PROPERTY</strong>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          a) The Content on ZEE5 and the &quot; ZEE5 &rdquo; word mark and the
          &ldquo;ZEE5&rdquo; design mark, as well as certain other of the names,
          logos, and materials displayed on or through ZEE5 that constitute
          trademarks, trade-names, service marks or logos (&quot; Marks &rdquo;)
          are owned by or licensed to Zee Entertainment Enterprises Limited and
          are subject to copyright, trademark, and other intellectual property
          rights under Indian laws. You agree not to reproduce, duplicate, copy,
          download, stream capture, archive, upload, publish, broadcast, sell,
          resell, modify, translate, decompile, disassemble, reverse engineer or
          exploit for any purposes the ZEE5 or any portion of the ZEE5,
          including, without limitation, the Content and the Marks, except as
          authorized by these TERMS or as otherwise authorized in writing by
          ZEEL. In addition, you are strictly prohibited from creating
          derivative works, or materials that otherwise are derived from or
          based on in any way the Content and the Marks, including montages,
          mash-ups and similar videos, wallpaper, desktop themes, greeting
          cards, and merchandise, except as authorized by these Terms or as
          otherwise authorized in writing by ZEEL. You must abide by all
          copyright notices, information, and restrictions contained in or
          associated with any Content. You must not remove, alter, interfere
          with, or circumvent any copyright, trademark, or other proprietary
          notices marked on the Content or any digital rights management
          mechanism, device or other content protection or access control
          measure (including, without limitation, geo-filtering and/or
          encryption) associated with the Content.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          b) The Participant agrees that all intellectual property rights, title
          and interest in the user generated content published or generated on
          the Application by the Participant shall solely vest with ZEEL.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <strong className="weight-bold">12. USER CONDUCT</strong>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          a) Participant(s) agree not to disrupt, overburden, or aid or assist
          in the disruption or overburdening of any computer or server used to
          offer or support ZEEL or ZEEL&rsquo;s services.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          b) Participant(s) shall not attempt to gain unauthorized access to the
          user accounts, servers or networks connected to ZEEL services by any
          means other than the user interface provided by ZEEL, including but
          not limited to, by circumventing or modifying, attempting to
          circumvent or modify, or encouraging or assisting any other person to
          circumvent or modify, any security, technology, device, or software
          that underlies or is part of the ZEEL&rsquo;s services.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          c) Participant(s) shall not attempt to transmit content regarding
          services, products, surveys, ZeeRewards, pyramid schemes, spam,
          unsolicited advertising or promotional materials, or chain letters.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <strong className="weight-bold">
          13. GENERAL RULES &amp; REGULATIONS
        </strong>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          a) The Participant&rsquo;s participation in ZeeRewards shall be
          considered to be acceptance of all Rules &amp; Regulations as set
          forth herein including the ZEE5 Privacy Policy.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          b) The Participant hereby represents that he/she is not under any
          contract, exclusive or otherwise, with any other third party/ agency
          or is not under any kind of disqualification or disability under law,
          to enter into an agreement with ZEEL or its associates and affiliates,
          as the case may be.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          c) The Participant shall undertake, warrant and guarantee to ZEEL that
          the Participant has the full legal capacity to participate in
          ZeeRewards, in accordance with these Rules &amp; Regulations.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          d) The Participant acknowledges that he/she has voluntarily chosen to
          participate in ZeeRewards at his / her free-will and is willing to
          bear all risk, costs &amp; consequences arising from such
          participation in ZeeRewards.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          e) The Participant shall not have any claim against ZEEL and/or any of
          its associates and affiliates connected with ZeeRewards. ZEEL, its
          associates and affiliates or vendors connected with ZeeRewards shall
          not be responsible for any such eventuality and the Participant(s)
          shall not be entitled to claim any compensation from ZEEL.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          f) In the event of any fault, misunderstanding or dispute concerning
          any part of ZeeRewards, and/or the operation of the telephone system,
          internet system, or the validity of any question or answer options,
          the decision of ZEEL shall be final and binding on all Participant(s)
          and other persons. ZEEL is empowered to take a decision on any case or
          instances not covered by the present Rules &amp; Regulations.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          g) ZEEL reserves the right to amend (add to, delete or modify) the
          Rules &amp; Regulations prospectively or retrospectively, at its
          discretion and without prior approval in order to improve ZeeRewards
          or remediate any issues that may occur. The Participant is requested
          to carefully read these Rules &amp; Regulations from time to time
          before using the Application for participating in the ZeeRewards. It
          shall be the Participant&rsquo;s responsibility to check these Rules
          &amp; Regulations periodically for changes.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          h) ZEEL has the sole right at any time/to alter/ amend/ withdraw/
          replace/discontinue and/or terminate ZeeRewards without any prior
          intimation or notice to the public and ZEEL is not obligated in any
          manner whatsoever to compensate any person(s) who have participated in
          ZeeRewards.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          i) If the operation of ZeeRewards is prevented by an event of force
          majeure or otherwise, ZEEL may cancel all or any part of ZeeRewards or
          take such other decision as it deems fit.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          j) If any provision of these Rules &amp; Regulations is held by any
          Court or other competent authority to be void or unenforceable in
          whole or part, the other provisions of these Rules &amp; Regulations
          and the remainder of the affected provisions shall continue to be
          valid. These Rules &amp; Regulations and ZeeRewards shall be governed
          by and construed in accordance with the laws of India and the
          Participant(s) submit irrevocably to the jurisdiction of the Courts in
          Mumbai.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          k) ZEEL is empowered to take a decision on any case not covered by the
          present Rules &amp; Regulations.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          l) ZEEL, its associates and affiliates will not be liable for any loss
          of earnings, employment or otherwise, caused to the Participant(s) and
          arising as a result of his/her participation in ZeeRewards.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          m) The Participant(s) hereby agree to indemnify ZEEL, its associates
          and affiliates against any claims that might arise from his/her
          actions or omissions while participating in ZeeRewards.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          n) The Participant hereby agrees and undertakes that, ZEEL is in no
          manner whatsoever responsible and/or shall not be held liable in any
          manner whatsoever, for any injury of any kind including mental and/or
          emotional trauma caused to the Participant(s) in any manner
          whatsoever, in relation to the ZeeRewards.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          o) The only way to enter ZeeRewards is through participation as
          described in these Rules &amp; Regulations. Any person claiming that
          he/she can help get you access to ZeeRewards for a consideration is
          defrauding you. Please contact your local police and report this
          person immediately.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          p) The Participant shall not have any ownership interest, license or
          other rights in the application for ZeeRewards or any right in
          ZeeRewards Intellectual Property therein, whether by license,
          implication, estoppel or otherwise.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          q) Subject to these Rules &amp; Regulations, ZEEL hereby grants you a
          limited, non-exclusive, non-sub licensable and non-transferable
          license, limited to the territory of India, to use ZeeRewards and the
          content solely for purposes of using ZeeRewards and services provided
          therein. The Participant acknowledges and agrees that he/she shall not
          copy, republish, post, display, translate, transmit, reproduce or
          distribute any content through any medium without obtaining the
          necessary authorization from ZEEL or thirty party owners of such
          content.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          r) ZEEL in its sole discretion may suspend or terminate and/or block
          the Participant(s) from accessing all or any part the Application
          and/or any service provided therein if he/she breaches or is suspected
          to be in breach of the Rules &amp; Regulations or any applicable law
          or if he/she is found to be misusing the Application or are engaged in
          illegal or fraudulent use of Application in any manner. Suspension or
          termination of the Participant&rsquo;s account may result in loss or
          destruction of any information/data associated with such account.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          s) All these Rules and Regulations are specific to the ZeeRewards and
          do not supersede or substitute the Terms of Use and Privacy Policy of
          using the Application.
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          t) Participant&rsquo;s correspondence, transactions and usage of the
          services of ZEEL shall be subject to the Terms &amp; Conditions, Rules
          &amp; Regulations, policies and other service terms
          adopted/implemented by ZEEL, and the Participant(s) shall be solely
          responsible for reviewing the same prior to transacting or availing of
          the services of ZEEL. Participant agrees that ZEEL will not be
          responsible or liable for any loss or damage of any sort incurred
          because of any issues related to transactions.
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        u) In case of any queries, please write to
        https://www.zee5.com/contactus/ setting out your concerns/issues related
        to the ZeeRewards. All endeavours shall be made to reply to the queries
        within reasonable time on a best effort basis. However, the absence of a
        reply shall not be deemed to mean acceptance by ZEEL of any claims made
        in the query.
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </>
  );
};

export default RewardsTermAndConditionsTempComponent;
